export enum CHECKBOX_STATE {
    Empty,
    Checked,
    Indeterminate,
}

export type TimeSlotItem = {
    key: number;
    value: number;
    isWeekDay: boolean;
    isChecked: boolean;
};
